<template>
	<div class="text-left" style="width: 1000px;">
		<common-header>
			<el-col :span="14">
				<el-steps :space="200" :active="1" finish-status="success" style="text-align: left;" align-center>
					<el-step title="选中商品"></el-step>
					<el-step title="填写核对订单信息"></el-step>
					<el-step title="成功提交订单"></el-step>
				</el-steps>
			</el-col>
		</common-header>
		<div class="container">
			<div>
				<p>选择收货地址</p>
				<div class="address">
					<template v-if="addressList.length > 8 && !this.opened">
						<div class="address-item" v-for="(item, index) in 8" :key="index" :class="{ active: index == addressCheckIndex }" @click="addressChange(index)">
							<div v-if="addressList[index].default" class="default">默认地址</div>
							<p class="title">
								<span>{{ addressList[index].address_name }}</span>
								<span>（{{ addressList[index].name }}收）</span>
							</p>
							<p class="detail">
								<span>{{ addressList[index].address }}</span>
								<span>{{ addressList[index].mobile }}</span>
							</p>
						</div>
					</template>
					<template v-else>
						<div
							class="address-item"
							v-for="(address, index) in addressList"
							:key="index"
							:class="{ active: index == addressCheckIndex }"
							@click="addressChange(index)"
						>
							<div v-if="address.default" class="default">默认地址</div>
							<p class="title">
								<span>{{ address.address_name }}</span>
								<span>（{{ address.name }}收）</span>
							</p>
							<p class="detail">
								<span>{{ address.address }}</span>
								<span>{{ address.mobile }}</span>
							</p>
						</div>
					</template>
				</div>
				<div class="flex address-operate">
					<div class="operate-item" @click="opened = !opened">
						<span>{{ opened ? '收起' : '展开' }}</span>
						<span><i :class="opened ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i></span>
					</div>
					<div class="operate-item">添加新地址</div>
				</div>
			</div>
			<!-- 订单信息 -->
			<div class="order">
				<el-divider content-position="left">确认订单信息</el-divider>
				<div class="order-header">
					<span class="goods-info">商品信息</span>
					<span class="goods-param">商品属性</span>
					<span class="goods-price">商品单价</span>
					<span class="goods-num">商品数量</span>
					<span class="goods-total">小计</span>
				</div>
				<div class="order-item" v-for="(goods, index) in buyList" :key="index">
					<div class="goods-info flex flex-start">
						<el-image :src="getWebPic(goods.smpic)"></el-image>
						<div class="goods-name">{{ goods.name }}</div>
					</div>
					<div class="goods-param">
						<div>{{ goods.param1 }}</div>
						<div>{{ goods.param2 }}</div>
					</div>
					<div class="goods-price">{{ computePrice(goods) }}</div>
					<div class="goods-num">{{ goods.number }}</div>
					<div class="goods-total flex" style="flex-direction: column;">
						<div class="goods-pay">{{ goods.realpay }}</div>
						<div class="delivery-text" v-if="goods.no_delivery_text">{{ goods.no_delivery_text }}</div>
						<!-- <div v-else class="extra-fee">需付运费</div> -->
					</div>
				</div>
				<!-- 额外支付 -->
				<div class="else-pay text-right">
					<div class="total">
						合计：
						<span class="total-info">{{ this.total }}</span>
					</div>
					<div class="else-fee">需付运费：{{ yunfei_fee }}</div>
				</div>
				<!-- 优惠券，积分抵扣等 -->
				<div class="coupon-score">
					<div class="">
						<el-collapse>
							<el-collapse-item name="1">
								<template slot="title">
									<div class="flex" style="flex:1">
										<div>优惠券</div>
										<div>
											选择
											<span v-if="coupon_checkId">{{ coupon_check_text }}</span>
										</div>
									</div>
								</template>
								<div class="coupon-list">
									<div
										class="coupon-item"
										v-for="(item, index) in couponList"
										:key="index"
										@click="chooseCoupon(index, item.id)"
										:class="total < item.min_pay ? 'discanuse' : ''"
									>
										<div class="con">
											<div class="left">
												<span class="title">{{ item.name }}</span>
												<span class="time">有效期{{ ctimeToDay(item.start_time) }}至{{ ctimeToDay(item.end_time) }}</span>
											</div>
											<div class="right">
												<span class="price">
													<span v-if="item.youhui_bili > 0">
														{{ item.youhui_bili * 10 }}
														<span style="font-size: 13px;">折</span>
													</span>
													<span v-else>{{ item.youhui_price }}</span>
												</span>
												<span v-if="item.min_pay > 0">满{{ item.min_pay }}可用</span>
												<span v-else>无门槛</span>
											</div>

											<div class="circle l"></div>
											<div class="circle r"></div>
										</div>
										<!-- <text class="tips" :class="item.id == coupon_checkId ? 'coupon_checked' : ''">{{ user_type_text(item.user_type) }}</text> -->
										<div class="tips flex" :class="item.id == coupon_checkId ? 'coupon_checked' : ''">
											<span>{{ user_type_text(item.user_type) }}</span>
											<span v-if="item.goods_category">限{{ item.goods_category_name }}类使用</span>
											<span v-if="item.apply_goods_ids.length" @click.stop="showApplyGoods(item.apply_goods)">
												自定义商品可用
												<span style="margin-left: 7px;color: #007AFF;">查看</span>
											</span>
										</div>
									</div>
								</div>
							</el-collapse-item>
						</el-collapse>
					</div>
					<div class="flex use-score">
						<!-- 积分 -->
						<span>使用积分</span>
						<span>
							<el-checkbox v-model="usejifen" class="use-jifen">可用{{ userInfo.jifen }}积分抵扣{{ jifendikou() }}元</el-checkbox>
						</span>
					</div>
				</div>
				<!-- 结算相关 -->
				<div class="pay-info flex text-right">
					<div class="beizhu">
						<el-row>
							<el-col :span="5">备注信息</el-col>
							<el-col :span="18">
								<el-input type="textarea" :rows="6" placeholder="请输入备注" v-model="desc"></el-input>
							</el-col>
						</el-row>
						</div>
					<div>
						<div class="border">
							<div class="real-pay">
								<span><strong>实付款：</strong></span>
								<span class="price">{{ needpay }}</span>
							</div>
							<div class="peisong-info">
								<div>
									配送至：
									<span>{{ addressData.full_address }}</span>
								</div>
								<div>
									<span>{{ addressData.name + ' ' + addressData.mobile }}</span>
									收
								</div>
							</div>
						</div>
						<div class="pay-btn"><el-button type="danger" :disabled="exit_no_delivery" @click="submit">去付款</el-button></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Cookie from 'js-cookie';
import { mapState, mapMutations, mapActions } from 'vuex';
import commonHeader from '../../components/common/commonHeader.vue';
export default {
	name: '',
	components: {
		commonHeader
	},
	data() {
		return {
			maskState: 0, //优惠券面板显示状态
			desc: '', //备注
			payType: 1, //1微信 2支付宝
			couponList: [],
			opened: false, //多出8个的地址是否展开
			addressList: [],
			addressCheckIndex: 0,
			addressData: '',
			buyList: [],
			orderid: '',
			requestApi: '',
			jumpfrom: '',
			buyType: '', //团购订单用
			coupon_checkId: '',
			coupon_checkIndex: '',
			coupon_check_text: '',
			total: 0,
			isvip: 0,
			shareId: '',
			usejifen: false,
			jifenbili: 100,
			usejifen_num: 0,
			sub_disabled: true,
			exit_no_delivery: false, //存在商品不配送地区的标志位
			yunfei_fee: 0, //运费
			modalShow: false,
			apply_goods: []
		};
	},
	computed: {
		...mapState({
			loginState: state => state.user.loginState,
			userInfo: state => JSON.parse(state.user.userInfo)
		}),
		needpay() {
			var price;
			if (!this.coupon_checkId) {
				price = this.total + this.yunfei_fee;
				console.log(price);
			} else {
				var index = this.coupon_checkIndex;
				if (this.couponList[index].youhui_bili > 0) {
					price = this.total * this.couponList[index].youhui_bili;
				} else {
					price = parseFloat(this.total) - parseFloat(this.couponList[index].youhui_price);
				}
				price += this.yunfei_fee;
			}
			if (this.usejifen) {
				price = price - this.jifendikou();
			}
			console.log(this.yunfei_fee);
			price = price > 0.01 ? price : 0.01;
			return Number(price).toFixed(2);
		}
	},
	mounted() {
		this.isvip = this.userInfo.vip;
		this.buyList = JSON.parse(localStorage.getItem('buyList_' + this.userInfo.id));
		this.total = localStorage.getItem('buyTotal_' + this.userInfo.id);
		this.total = Number(this.total);
		this.jumpfrom = this.$route.query.jumpfrom;
		if (this.buyList[0].buyType) {
			this.requestApi = '/home.order/createTuangouOrder';
			this.buyType = this.buyList[0].buyType;
		} else {
			this.requestApi = '/home.order/createOrder';
		}
		// 运费计算
		this.$on('checkAddress', () => {
			this.exit_no_delivery = false;
			this.sub_disabled = true;
			var addressCode = this.addressData.shi;
			for (let i in this.buyList) {
				var yfModel = this.buyList[i].yunfeiModel;
				var no_delivery_area = JSON.parse(yfModel.no_delivery_area);
				if (no_delivery_area.length) {
					for (let n in no_delivery_area) {
						if (no_delivery_area[n].areacode.indexOf(addressCode) != -1) {
							this.buyList[i].no_delivery_text = '该商品当前地区不支持配送';
							this.exit_no_delivery = true;
						} else {
							this.buyList[i].no_delivery_text = '';
						}
					}
				}
				if (this.buyList[i].yunfeiModel.type > 0) {
					var { unit, unit_text } = this.getYfType(this.buyList[i].yunfeiModel.type);
					this.buyList[i].first = parseFloat(this.buyList[i].yunfeiModel['de_' + unit]);
					this.buyList[i].first_fee = parseFloat(this.buyList[i].yunfeiModel['de_' + unit + '_fee']);
					this.buyList[i].add = parseFloat(this.buyList[i].yunfeiModel['add_' + unit]);
					this.buyList[i].add_fee = parseFloat(this.buyList[i].yunfeiModel['add_' + unit + '_fee']);

					var else_fee = JSON.parse(yfModel.else_fee);
					if (else_fee.length) {
						for (let n in else_fee) {
							if (else_fee[n].areacode.indexOf(addressCode) != -1) {
								console.log(addressCode);
								this.buyList[i].first = parseFloat(else_fee[n].first);
								this.buyList[i].first_fee = parseFloat(else_fee[n].first_fee);
								this.buyList[i].add = parseFloat(else_fee[n].add);
								this.buyList[i].add_fee = parseFloat(else_fee[n].add_fee);
								break;
							}
						}
					}
				}
			}

			if (!this.exit_no_delivery) {
				// 表示当前地区 购买的商品可以配送,计算运费;
				// 每种商品单独计算,称重的体积的,每个商品参数单独算,计件的,商品算
				var list = JSON.parse(JSON.stringify(this.buyList));
				console.log(list);
				var new_arr = [];
				var yunfei_fee = 0;
				for (let i in list) {
					list[i].number = Number(list[i].number);
					if (list[i].yunfeiModel.type == 1) {
						// 计件收费,算当前商品各个参数的总量
						for (let n in list) {
							if (list[n].goods_id == list[i].goods_id && n != i) {
								list[i].number += Number(list[n].number);
								list.splice(n, 1);
							}
						}
					}
					new_arr.push(list[i]);
				}
				console.log('new_arr', new_arr);
				for (let i in new_arr) {
					if (new_arr[i].yunfeiModel.type > 0) {
						var item = new_arr[i];
						var fee = 0;
						var add_exit = 0;
						if (item.yunfeiModel.type == 1) {
							add_exit = Number(item.number) - item.first;
						} else {
							item.yunfei_param = parseFloat(item.yunfei_param);
							add_exit = Number(item.number) * item.yunfei_param - item.first;
						}
						if (add_exit > 0) {
							fee = item.first_fee + Math.ceil(add_exit / item.add) * item.add_fee;
						} else {
							fee = item.first_fee;
						}
						console.log('fee', fee);
						yunfei_fee += fee;
					}
				}
				console.log('yunfei_fee', yunfei_fee);
				this.yunfei_fee = yunfei_fee;
				this.sub_disabled = false;
			}
		});

		this.getAddress();
		this.getCouponList();
	},
	methods: {
		...mapMutations({
			setCartnum: 'user/setCartnum'
		}),
		computePrice(goods) {
			var price;
			if (goods.zhekouType == 1) {
				price = Number((goods.price * this.userInfo.vipZhekou * 100) / 100).toFixed(2);
			} else {
				price = goods.vipprice;
			}
			return price;
		},
		getAddress() {
			this.$request
				.post('/home.user/getDefaultAddress', {
					userid: this.userInfo.id ? this.userInfo.id : '',
					token: this.userInfo.token ? this.userInfo.token : ''
				})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'userinfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.addressList = res.data.address;
						if (this.addressList.length) {
							this.addressData = this.addressList[0];
							this.$emit('checkAddress');
						}
						this.jifenbili = res.data.jifenbili;
					}
				})
				.catch(err => {
					console.log(err);
				});
		},
		getCouponList() {
			this.$request
				.post('/home.user/getCouponList', {
					userid: this.userInfo.id ? this.userInfo.id : '',
					token: this.userInfo.token ? this.userInfo.token : ''
				})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'userinfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.couponList = res.data.couponList;
						for (let i in this.couponList) {
							this.couponList[i].apply_goods = JSON.parse(this.couponList[i].apply_goods);
							this.couponList[i].apply_goods_ids = JSON.parse(this.couponList[i].apply_goods_ids);
						}
					}
				})
				.catch(err => {
					console.log(err);
				});
		},
		addressChange(e) {
			this.addressCheckIndex = e;
			this.addressData = this.addressList[e];
			console.log(this.addressData);
			this.$emit('checkAddress');
		},
		getYfType(type) {
			var unit, unit_text;
			switch (type) {
				case 1:
					unit = 'num';
					unit_text = '件';
					break;
				case 2:
					unit = 'kg';
					unit_text = 'kg';
					break;
				case 3:
					unit = 'm3';
					unit_text = 'm3';
					break;
				default:
					unit = 'num';
					unit_text = '件';
					break;
			}
			return { unit, unit_text };
		},
		user_type_text(type) {
			switch (type) {
				case 1:
					return '全体用户可用';
				case 2:
					return '限新用户使用';
				case 3:
					return '限会员用户使用';
				case 4:
					return '限分销员使用';
				default:
					return '全体用户可用';
			}
		},
		// 选择优惠券
		chooseCoupon(index, couponId) {
			// 先判断当前选择优惠券是否可用
			var coupon = this.couponList[index];
			var min_pay = coupon.min_pay;
			var key = coupon.goods_category_level - 2;
			var timestamp = Date.parse(new Date()) / 1000;
			if (timestamp < coupon.start_time) {
				this.$message.error('不符合优惠券使用时间');
				return false;
			}
			if (this.total < min_pay) {
				this.$message.error('不符合优惠券使用条件');
			} else {
				var pay = Number(this.needpay);
				console.log(pay);
				if (pay < min_pay) {
					console.log('pay-minpay:', pay, min_pay);
					this.$message.error('不符合优惠券使用条件');
					return false;
				}
				this.coupon_checkId = this.coupon_checkId == couponId ? '' : couponId;
				this.coupon_checkIndex = this.coupon_checkIndex === index ? '' : index;
				if (coupon.youhui_bili > 0) {
					this.coupon_check_text = coupon.youhui_bili * 10 + '折';
				} else {
					this.coupon_check_text = '-￥' + coupon.youhui_price;
				}
			}
		},
		jifendikou() {
			console.log(this.userInfo.jifen, this.jifenbili);
			var p = (parseFloat(this.userInfo.jifen) / parseFloat(this.jifenbili)).toFixed(2);
			return p;
		},
		submit(){
			this.$emit('showLoading',true);
			this.$request.post(this.requestApi,{
				buyList: this.buyList,
				addressData: this.addressData,
				beizhu: this.desc,
				jumpfrom: this.jumpfrom,
				buyType: this.buyType,
				userid: this.userInfo.id,
				token: this.userInfo.token,
				coupon_checkId: this.coupon_checkId,
				isvip: this.isvip,
				shareId: this.shareId,
				total:this.needpay,
				usejifen:this.usejifen_num,
				yunfei_fee:this.yunfei_fee
			})
			.then(res=>{
				this.$emit('showLoading',false)
				console.log(res);
				if (res.data.status == 0) {
					this.$message.error(res.data.msg);
					if (res.data.admin_err == 'userinfo_error') {
						this.exit().then(res => {
							console.log(res);
							if (res.actionStatus == 1) {
								this.$router.push('/login');
							}
						});
					}
				} else {
					if(res.data.status == 1){
						if(this.jumpfrom == 'cart'){
							this.setCartnum(res.data.cartnum);
						}
						localStorage.setItem('orderpay_'+this.userInfo.id,JSON.stringify(res.data.order));
						this.$router.push({'path':'/order/orderPay'});
					}
				}
			})
			.catch(err=>{
				this.$emit('showLoading',false)
			})
		}
	}
};
</script>
<style lang="scss">
.address {
	position: relative;
	display: grid;
	grid-gap: 15px;
	grid-template-columns: repeat(auto-fill, 237px);
	grid-template-rows: repeat(auto-fill, 106px);
	.address-item {
		position: relative;
		cursor: pointer;
		width: 237px;
		height: 106px;
		padding: 11px 15px;
		font-size: 14px;
		word-break: break-all;
		background: url(../../assets/address.png);
		&:hover,
		&.active {
			background: url(../../assets/address_active.png);
		}
		&.active {
			&::after {
				content: url(../../assets/address_checked.png);
				position: absolute;
				bottom: -2px;
				right: 0;
			}
		}
		p.title {
			font-weight: bold;
		}
		p.detail {
			span:last-child {
				margin-left: 7px;
			}
		}
		.default {
			position: absolute;
			top: 0;
			right: 0;
			background: rgba($color: #bcbcbc, $alpha: 0.8);
			color: #fff;
			font-size: 12px;
			padding: 0 3px;
		}
	}
}
.address-operate {
	line-height: 40px;
	div.operate-item {
		cursor: pointer;
		&:hover {
			color: #ff9d00;
		}
	}
}
.order {
	.order-header {
		line-height: 35px;
		span {
			display: inline-block;
			text-align: center;
			border-bottom: 3px solid #b2d1ff;
			border-right: 3px solid #fff;
			box-sizing: border-box;
		}
	}
	.order-item {
		height: 100px;
		display: flex;
		padding: 10px 0;
		border-bottom: 1px dotted #0066cc;
		box-sizing: content-box;
		> div {
			height: 100px;
			text-align: center;
			line-height: 30px;
			&.goods-info {
				text-align: left;
				.el-image {
					width: 100px;
					height: 100px;
				}
				.goods-name {
					line-height: 24px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 4;
					margin-left: 7px;
					flex: 1;
				}
			}
			&.goods-param {
				color: gray;
			}
			&.goods-total {
				text-align: right;
				.goods-pay {
					color: red;
					font-size: 17px;
					font-weight: bold;
				}
				.extra-fee {
					font-size: 14px;
				}
				.delivery-text {
					color: red;
				}
			}
		}
	}
	.goods-info {
		width: 315px;
	}
	.goods-param {
		width: 200px;
	}
	.goods-price {
		width: 140px;
	}
	.goods-num {
		width: 130px;
	}
	.goods-total {
		width: 180px;
	}
	.else-pay {
		line-height: 35px;
		.total {
			.total-info {
				color: red;
				font-size: 17px;
				font-weight: bold;
				&::before {
					content: '￥';
				}
			}
			.else-fee {
				&::before {
					content: '￥';
				}
			}
		}
	}
	.coupon-score {
		.use-score {
			line-height: 48px;
			border-bottom: 1px solid #ebeef5;
			.use-jifen {
				span {
					float: right;
					display: inline-block;
				}
				.el-checkbox__inner {
					margin-left: 5px;
					margin-top: 2px;
					width: 18px;
					height: 18px;
				}
			}
		}
	}
	.pay-info {
		.beizhu{
			width: 400px;
			padding-top: 15px;
			text-align: left;
		}
		.border {
			margin-top: 15px;
			border: 3px solid #ea5725;
			padding: 10px 25px;
		}
		.real-pay {
			line-height: 40px;
			.price {
				font-size: 24px;
				font-weight: bold;
				color: red;
				&:before {
					content: '￥';
					color: gray;
				}
			}
		}
		.peisong-info {
			line-height: 30px;
		}
	}
}
</style>
